export default __webpack_public_path__ + "static/media/foresters-insurance-logo-450x127.24ac999a.png";